<div class="flex justify-between pb-1"><label for="{{id}}" class=" block tk-skolar-latin m-0 text-base font-bold">{{label}}</label> <p class="text-sm font-thin m-0" *ngIf="maxLength">{{input.value.length}}/{{maxLength}} tecken</p></div>
<input #input type="text" [attr.maxlength]="maxLength" class="block w-full bg-white rounded border-gray-200 border-2 h-12 px-2 text-base" [id]="id" (keyup)="onValueChange($event)">


